import script from "./ServiceGoals.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceGoals.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceGoals.vue?vue&type=style&index=0&id=8bc83488&lang=scss"

const __exports__ = script;

export default __exports__